import actions from '@/store/modules/medias/actions';
import getters from '@/store/modules/medias/getters';
import mutations from '@/store/modules/medias/mutations';
import state from '@/store/modules/medias/state';

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
